import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export var resetConsumerDefaultFromStore = mutatorAction('resetConsumerDefaultFromStore', function (options) {
    var store = connectedAccountsStore();
    store.defaultFromState.emailAddresses = [];
    store.defaultFromState.consumerMailboxOptions = options;
    var sessionSettings = getUserConfiguration().SessionSettings;
    var emailAddresses = [];
    var defaultAddress = options.DefaultFromAddress ||
        sessionSettings.DefaultFromAddress ||
        sessionSettings.UserEmailAddress;
    store.defaultFromState.defaultFromAddress = defaultAddress;
    store.defaultFromState.emailAddresses.push({
        key: emailAddresses.length.toString(),
        text: store.defaultFromState.defaultFromAddress,
    });
    emailAddresses.push(store.defaultFromState.defaultFromAddress);
    var userProxyAddresses = options.EmailAddresses;
    if (userProxyAddresses && userProxyAddresses.length > 0) {
        for (var _i = 0, userProxyAddresses_1 = userProxyAddresses; _i < userProxyAddresses_1.length; _i++) {
            var emailAddress = userProxyAddresses_1[_i];
            if (emailAddresses.indexOf(emailAddress) < 0) {
                store.defaultFromState.emailAddresses.push({
                    key: emailAddresses.length.toString(),
                    text: emailAddress,
                });
                emailAddresses.push(emailAddress);
            }
        }
    }
    var notManagedEmailAddresses = options.NotManagedEmailAddresses;
    if (notManagedEmailAddresses && notManagedEmailAddresses.length > 0) {
        for (var _a = 0, notManagedEmailAddresses_1 = notManagedEmailAddresses; _a < notManagedEmailAddresses_1.length; _a++) {
            var emailAddress = notManagedEmailAddresses_1[_a];
            if (emailAddresses.indexOf(emailAddress) < 0) {
                store.defaultFromState.emailAddresses.push({
                    key: emailAddresses.length.toString(),
                    text: emailAddress,
                });
                emailAddresses.push(emailAddress);
            }
        }
    }
    var accounts = options.SendEnabledConnectedAccounts;
    if (accounts && accounts.length > 0) {
        for (var _b = 0, accounts_1 = accounts; _b < accounts_1.length; _b++) {
            var account = accounts_1[_b];
            if (emailAddresses.indexOf(account.EmailAddress) < 0) {
                store.defaultFromState.emailAddresses.push({
                    key: emailAddresses.length.toString(),
                    text: account.EmailAddress,
                });
                emailAddresses.push(account.EmailAddress);
            }
        }
    }
});
//# sourceMappingURL=resetConsumerDefaultFromStore.js.map